"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.wrapRootElement = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@chakra-ui/core");

var _theme = _interopRequireDefault(require("./theme"));

var wrapRootElement = function wrapRootElement(_ref, _ref2) {
  var element = _ref.element;
  var _ref2$isResettingCSS = _ref2.isResettingCSS,
      isResettingCSS = _ref2$isResettingCSS === void 0 ? true : _ref2$isResettingCSS,
      _ref2$isUsingColorMod = _ref2.isUsingColorMode,
      isUsingColorMode = _ref2$isUsingColorMod === void 0 ? true : _ref2$isUsingColorMod;
  return _react["default"].createElement(_core.ThemeProvider, {
    theme: _theme["default"]
  }, isResettingCSS && !isUsingColorMode && _react["default"].createElement(_core.CSSReset, null), isUsingColorMode ? _react["default"].createElement(_core.ColorModeProvider, null, isResettingCSS && _react["default"].createElement(_core.CSSReset, null), element) : element);
};

exports.wrapRootElement = wrapRootElement;